// ** Redux Imports
import { createSlice, createAsyncThunk, current, PayloadAction } from '@reduxjs/toolkit'
import axiosInstance from '../../shared/authentication/AxiosInterceptor'
import { CustomMasterData } from '../models/CustomMasterData'

// ** Axios Imports

export const getCustomMaster = createAsyncThunk('customMaster/getCustomMaster', async (id) => {
    const response = await axiosInstance.get(`custom-master/${id}`)
    return response.data
})

export const configuration = createAsyncThunk('customMaster/configuration', async (id) => {
    const response = await axiosInstance.get(`/app-configuration`)
    return response.data
})


export const getOptionAppLayout = createAsyncThunk('customMaster/getOption', async (data) => {
    const {name, locationId} = data;
    const locationList = [locationId];

    const response = await axiosInstance.get(`custom-master/option/${name}`, {
            headers: {
                "X-Custom-Location": locationList.join(","), // Convert the list of integers to a comma-separated string
            },
        })
    return response.data
})

export const getOption = createAsyncThunk('customMaster/getOption', async (name) => {
    const response = await axiosInstance.get(`custom-master/option/${name}`)
    return response.data
})

export const getNewUnitOptions = createAsyncThunk('getnew/unitvalues', async () => {
    const response = await axiosInstance.get(`store-product/v2/meta/units`);
    return response.data;
})

export const getCustomMasterList = createAsyncThunk('customMaster/getCustomMasterList', async () => {
    const response = await axiosInstance.get('custom-master')
    return response.data
})

export const fetchWalletLaw = createAsyncThunk('fetchWalletLawData', async (storeId) => {
    const response =  await axiosInstance.get(`/app/customer/get-wallet-law?storeId=${storeId}`)
    return response.data
})

export const updateWalletLaw = createAsyncThunk('updateWalletLaw', async (data) => {
    const response = await axiosInstance.post('/customer/update-wallet-law', data)
    return response.data
})

export const addCustomMaster = createAsyncThunk('customMaster/addCustomMaster', async (data) => {
    const response = await axiosInstance.post('custom-master', data)
    return response.data
})

export const editConfig = createAsyncThunk('customMaster/editConfig', async (data) => {
    const response = await axiosInstance.put('/app-configuration', data)
    return response.data
})


export const deleteCustomMasterItem = createAsyncThunk('customMaster/deleteCustomMasterItem', async (id) => {
    const response = await axiosInstance.delete(`custom-master/item/${id}`)
    return response.data
})

/** GET /transaction/paymentGateway?storeId= — effective config; use storeId 0 for platform default (admin). */
export const getPaymentGatewayConfig = createAsyncThunk(
    'transaction/getPaymentGateway',
    async (storeId) => {
        const sid =
            storeId === undefined || storeId === null || storeId === ''
                ? 0
                : Number(storeId)
        const response = await axiosInstance.get(`transaction/paymentGateway`, {
            params: { storeId: sid },
        })
        return response.data
    }
)

/**
 * GET /transaction/paymentGateway/list — allowed gateway enum names for UI radios.
 * Optional { storeId } or { countryCode } filters the list to gateways enabled for
 * that store's / that country's market. No arg → full list, exactly as before.
 */
export const getPaymentGatewayList = createAsyncThunk(
    'transaction/getPaymentGatewayList',
    async (arg) => {
        const params = {}
        if (arg && arg.storeId !== undefined && arg.storeId !== null && arg.storeId !== '') {
            params.storeId = arg.storeId
        }
        if (arg && arg.countryCode) {
            params.countryCode = arg.countryCode
        }
        const response = await axiosInstance.get(`transaction/paymentGateway/list`, { params })
        return response.data
    }
)

/** POST /transaction/paymentGateway — body: { storeId, paymentGateway, paymentTransactionFees } (storeId 0 = platform default). */
export const configurePaymentGateway = createAsyncThunk('transaction/paymentGateway', async (data) => {
    const body = {
        ...data,
        storeId:
            data.storeId === undefined || data.storeId === null
                ? 0
                : Number(data.storeId),
    }
    const response = await axiosInstance.post(`transaction/paymentGateway`, body)
    return response.data
})

const initialState = {
    customMaster: [CustomMasterData]
}

export const customMasterSlice = createSlice({
    name: 'customMaster',
    initialState,
    reducers: {

        setCustomerMasterList: (state, action) => {
            Object.assign(state.customMaster, action.payload)
        },
        addCustomMasterItem: (state, action) => {
            let newList = state.customMaster.map((obj) => {
                if (obj.id === action.payload.id) {
                    return { ...obj, ...action.payload }
                } else {
                    return { ...obj }
                }
            })
            Object.assign(state.customMaster, newList)
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getCustomMasterList.fulfilled, (state, action) => {
                let newList = action.payload.map((obj) => {
                    let temp = obj
                    temp.customMasterItems = temp.customMasterItems.sort((a, b) => {
                        var textA = a.name.toUpperCase()
                        var textB = b.name.toUpperCase()
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                    })
                    return temp
                })
                Object.assign(state.customMaster, newList)

            })
            .addCase(addCustomMaster.fulfilled, (state, action) => {
                let newList = state.customMaster.map((obj) => {
                    let temp
                    if (obj.id === action.payload.id) {
                        temp = { ...obj, ...action.payload }
                    } else {
                        temp = { ...obj }
                    }
                    temp.customMasterItems = temp.customMasterItems.sort((a, b) => {
                        var textA = a.name.toUpperCase()
                        var textB = b.name.toUpperCase()
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                    })
                    return temp
                })
                Object.assign(state.customMaster, newList)
            })
    }
})

export const { setCustomerMasterList, addCustomMasterItem } = customMasterSlice.actions


export default customMasterSlice.reducer
